import styled from "styled-components";

export const ModalProdutosContainer = styled.div`
  color: #380f52;

  .total-produtos {
    width: 100%;
    display: flex;
    justify-content: space-between;
  }

  h3 {
    margin: 10px;
  }
`;
